import { useAuth0 } from '@auth0/auth0-react';
import { type FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Logo } from 'src/components/atoms/Logo/Logo';
import { AccountMenu } from 'src/components/molecules/AccountMenu/AccountMenu';
import { ConfirmDialog } from 'src/components/molecules/ConfirmDialog/ConfirmDialog';
import { LanguageSwitch } from 'src/components/molecules/LanguageSwitch/LanguageSwitch';
import style from './Header.module.scss';

export const Header: FunctionComponent = () => {
  const { t } = useTranslation();
  const { isAuthenticated, user, logout } = useAuth0();
  const [asking, setAsking] = useState(false);

  return (
    <header className={style.header}>
      <div className={`container ${style.bar}`}>
        <Link to="/bands" className={style.wordmark}>
          <Logo />
        </Link>
        <div className={style.tools}>
          <LanguageSwitch />
          {isAuthenticated && user ? (
            <AccountMenu
              name={user.name ?? user.nickname ?? user.email ?? ''}
              email={user.email}
              picture={user.picture}
              onSignOut={() => setAsking(true)}
            />
          ) : null}
        </div>
      </div>
      {asking ? (
        <ConfirmDialog
          title={t('header.confirm.title')}
          text={t('header.confirm.text')}
          confirm={t('header.signOut')}
          cancel={t('header.confirm.stay')}
          onConfirm={() => void logout({ logoutParams: { returnTo: `${window.location.origin}/login` } })}
          onCancel={() => setAsking(false)}
        />
      ) : null}
    </header>
  );
};
